import { FORM_ERROR } from 'final-form';
export default FORM_ERROR;